const targets = [
  document.getElementById('CartDrawer'),
  document.getElementById('cart')
].filter(Boolean);

const tagVariantMap = {
  eofy_pack_starter: 50944645234921,
  eofy_pack_printer: 50944713392361,
  eofy_pack_premium: 50944714703081
};

let isUpdating = false;
let debounceTimer;

const config = { 
  childList: true,
  subtree: true
};

const runLogic = async () => {
  if (isUpdating) return;
  isUpdating = true;

  const drawer = document.getElementById('CartDrawer');
  const load = document.getElementById("CartDrawer-LineItemStatus");
  const loading = document.getElementById("shopping-cart-line-item-status");

  if (drawer) {
    drawer.style.pointerEvents = 'none';
    drawer.style.opacity = '0.9';
    load?.classList.remove('visually-hidden');
    loading?.classList.remove('visually-hidden');
  }

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    if (!cart.items?.length) {
      isUpdating = false;
      return;
    }

    const elements = document.querySelectorAll('.cart-item, .cart__item');

    const allTags = cart.items.flatMap(item => {
      const el = Array.from(elements).find(e =>
        e.querySelector('[data-quantity-variant-id]')?.dataset.quantityVariantId == item.id
      );

      if (!el) return [];

      try {
        return JSON.parse(el.dataset.productTags || '[]');
      } catch {
        return [];
      }
    });

    for (const [tag, variantId] of Object.entries(tagVariantMap)) {

      const hasTaggedProduct = allTags.includes(tag);
      const hasFreeProduct = cart.items.some(i => i.id === variantId);

      if (hasTaggedProduct && !hasFreeProduct) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        await refreshCartDrawer();
        break; 
      }

      if (!hasTaggedProduct && hasFreeProduct) {
        const updates = {};

        cart.items.forEach(item => {
          if (item.id === variantId) {
            updates[item.key] = 0;
          }
        });

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        if (window.location.pathname === '/cart') {
          location.reload();
        } else {
          await refreshCartDrawer();
        }

        break;
      }
    }

  } catch (e) {
    console.error('Cart logic error:', e);
  }

  setTimeout(() => {
    if (drawer) {
      drawer.style.pointerEvents = '';
      drawer.style.opacity = '1';
      load?.classList.add('visually-hidden');
      loading?.classList.add('visually-hidden');
    }

    isUpdating = false;
  }, 50);
};

const callback = () => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(runLogic, 50);
};

targets.forEach(target => {
  new MutationObserver(callback).observe(target, config);
});

const refreshCartDrawer = async () => {
  try {
    const html = await fetch('/cart?section_id=cart-drawer').then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('#CartDrawer');
    const currentDrawer = document.querySelector('#CartDrawer');
    const Drawer1 = document.querySelector('.drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;

      const hasItems = newDrawer.querySelector('.cart-item, .cart__item');

      Drawer1?.classList.toggle('is-empty', !hasItems);
    }
  } catch (err) {
    console.error('Drawer refresh failed:', err);
  }
};